import Image from 'app/components/layouts/Image';
import { useTranslation } from 'next-i18next';

interface InstructProps {
  count?: number;
}

const Instruct = ({ count }: InstructProps) => {
  const { t } = useTranslation();

  const instructions = [
    { icon: 'icon_parts', title: count ? t('speaking.speak_instruction', { count }) : t('ielt_speak_instructions.instruction1') },
    { icon: 'icon_time', title: t('ielt_speak_instructions.instruction2') },
    { icon: 'icon_computer', title: t('ielt_speak_instructions.instruction3') },
    { icon: 'icon_submit', title: t('ielt_speak_instructions.instruction4') },
    { icon: 'icon_review', title: t('ielt_speak_instructions.instruction5') },
    { icon: 'icon_setting', title: t('ielt_speak_instructions.instruction6') }
  ];

  return (
    <div id="step-general-instructions" className="my-4 speaking-test">
      <div className="instruction">
        <h3 className="instruction__title text-center">{t('ielt_speak_instructions.title')}</h3>
        <ul className="instruction__list">
          {instructions.map(item => {
            return (
              <li key={item.icon} className="instruction__item d-flex">
                <Image
                  style={{ maxWidth: 40 }}
                  alt="item.icon" className="mr-3"
                  src={`/images/tests/ielts/${item.icon}.svg`}
                />
                <span className="pt-2">{item.title}</span>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default Instruct
